import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlycaUiInputTextComponent } from '../input-text.component';

@Component({
  selector: 'plyca-ui-input-text-demo',
  templateUrl: './input-text-demo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PlycaUiInputTextComponent]
})
export class PlycaUiFormInputTextDemoComponent {}
